import { createFileRoute, redirect } from "@tanstack/react-router";

// 301-style redirect: /en/wdec & /es/wdec → /gestao-de-atendimento
export const Route = createFileRoute("/$locale/wdec")({
  beforeLoad: () => {
    throw redirect({ to: "/gestao-de-atendimento", replace: true });
  },
  component: () => null,
});
